import React from "react";

const SummaryTab = () => {
  return <> Summary </>;
};

export default SummaryTab;